import * as React from 'react';
import '../models/adyen/payment-type.js';
import { PaymentMethod } from '../models/cart-payment-methods/cart-payment-methods.js';
import '../models/googlePay/types.js';
import '../models/payment/types.js';
import '../models/paypal/context.js';
import { useIsExpressPaymentMethodSupported } from './use-is-express-payment-method-supported.js';

const useIsGooglePaySupportedForCart = (cartId)=>{
    const [getIsGooglePaySupportedForCart, { isPaymentMethodSupported , called , loading , error , paymentConfiguration  }, ] = useIsExpressPaymentMethodSupported(PaymentMethod.GOOGLE_PAY);
    React.useEffect(()=>{
        if (cartId) {
            getIsGooglePaySupportedForCart(cartId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cartId
    ]);
    return {
        isGooglePaySupportedForCart: isPaymentMethodSupported,
        paymentConfiguration,
        loading,
        called,
        error
    };
};

export { useIsGooglePaySupportedForCart };
//# sourceMappingURL=use-is-google-pay-supported-for-cart.js.map
